import Button from "./Button";
import {
  blackColor,
  greenHighlightColor,
  whiteColor,
} from "../constants/colors";
import { SuccessIcon } from "./Icons";

interface AlertPorps {
  alertText?: string;
  handleClick?: () => void;
  buttonWidth?: string;
  buttonHeight?: string;
  borderRadius?: string;
  buttonTitle?: string;
  paddingBlock?: string;
  backgroundColor?: string;
  iconSource?: string;
  altIcon?: string;
  alertText2?: string;
  alertText1?: string;
  iconSize?: string;
  alertTextColor?: string;
  cardWidth?: string;
  cardHeight?: string;
  showIcon?: boolean;
}

export const AltertBox: React.FC<AlertPorps> = ({ ...props }) => {
  const {
    alertTextColor,
    alertText,
    alertText1,
    alertText2,
    handleClick,
    iconSize,
    iconSource,
    altIcon,
    borderRadius,
    buttonHeight,
    buttonTitle,
    buttonWidth,
    paddingBlock,
    backgroundColor,
    showIcon,
    cardHeight,
    cardWidth,
  } = props;
  return (
    <>
      <div
        style={{
          width: "100%",
          backgroundColor: "rgba(0,0,0,.5)",
          position: "fixed",
          top: "0",
          left: "0",
          right: 0,
          bottom: 0,
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 50,
        }}
      >
        <div
          style={{
            width: cardWidth || "580px",
            borderRadius: "10px",
            height: cardHeight || "380px",
            marginInline: "auto",
            alignSelf: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            backgroundColor: whiteColor,
            paddingInline: "40px",
            paddingBottom: "10px",
          }}
        >
          {showIcon && (
            <div className="flex justify-center">
              <SuccessIcon className={"w-[86px] items-center"} />
            </div>
          )}

          <p
            style={{
              color: alertTextColor || greenHighlightColor,
              textAlign: "center",
              fontSize: 24,
              fontWeight: "600",
              marginBlock: "10px",
            }}
          >
            {alertText}
          </p>
          <p className=" text-custom-gray text-center text-[16px] leading-7">
            {alertText1}
          </p>
          <p style={{ color: blackColor, textAlign: "center", fontSize: 16 }}>
            {alertText2}
          </p>
          <div
            style={{
              width: "95%",
              display: "flex",
              justifyContent: "center",
              marginBlock: "20px",
              marginInline: "auto",
            }}
            onClick={handleClick}
          >
            <Button
              type="button"
              style={{ height: "50px", width: "100%", borderRadius: "10px" }}
              width={buttonWidth}
              height={buttonHeight}
              backgroundColor={backgroundColor}
              borderRadius={borderRadius}
              titleStyle={{ textAlign: "center" }}
              buttonTitle={buttonTitle}
              paddingBlock={paddingBlock}
            />
          </div>
        </div>
      </div>
    </>
  );
};
